export default {
    log({
        category, eventName, payload
    }) {
        const timestamp = new Date().toString();
        console.log(timestamp, category, eventName, payload);
    }
};